import { SET_LOCATION_ATTRIBUTE } from 'vx/mutations'

export default {
  computed: {
    user: {
      get () {
        return this.location.user_id
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'user_id', value })
      }
    },

    name: {
      get () {
        return this.location.name
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'name', value })
      }
    },

    streetNumber: {
      get () {
        return this.location.street_number
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'street_number', value })
      }
    },

    streetName: {
      get () {
        return this.location.street_name
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'street_name', value })
      }
    },

    suburb: {
      get () {
        return this.location.suburb
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'suburb', value })
      }
    },

    state: {
      get () {
        return this.location.state
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'state', value })
      }
    },

    postcode: {
      get () {
        return this.location.postcode
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'postcode', value })
      }
    },

    uhfChannel: {
      get () {
        return this.location.uhf_channel
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'uhf_channel', value })
      }
    },

    hoursOfLoading: {
      get () {
        return this.location.hours_of_loading
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'hours_of_loading', value })
      }
    },

    directions: {
      get () {
        return this.location.directions
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'directions', value })
      }
    },

    contactName: {
      get () {
        return this.location.contact_name
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'contact_name', value })
      }
    },

    secondaryContactName: {
      get () {
        return this.location.secondary_contact_name
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'secondary_contact_name', value })
      }
    },

    contactPhone: {
      get () {
        return this.location.contact_phone
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'contact_phone', value })
      }
    },

    contactSecondPhone: {
      get () {
        return this.location.contact_second_phone
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'contact_second_phone', value })
      }
    },

    contactEmail: {
      get () {
        return this.location.contact_email
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'contact_email', value })
      }
    },

    latitude: {
      get () {
        return this.location.latitude
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'latitude', value })
      }
    },

    longitude: {
      get () {
        return this.location.longitude
      },

      set (value) {
        this[SET_LOCATION_ATTRIBUTE]({ attribute: 'longitude', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/locations/state-mapper.js